import React from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  ListGroupItem,
  Col,
  Row,
  ListGroup,
} from "reactstrap";

import moment from "moment";

const LIMIT_YEAR = 2000;

const anios = [];
let anio = moment().get("year");

while (anio >= LIMIT_YEAR) {
  anios.push(anio);
  anio = moment().subtract(anios.length, "year").get("year");
}

const IndicadoresProyeccionModal = ({
  indicadoresEstablecimiento,
  onClose,
}) => {
  return (
    <Modal size="md" isOpen={true}>
      <ModalHeader>Indicadores de Uso de Potrero</ModalHeader>
      <ModalBody className="text-center">
        <ListGroup>
          <ListGroupItem className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <span className="text-left text-muted">
                Posibilidad de pastoreo en el corto plazo
              </span>
              <small className="text-left text-muted">
                Porcentaje del área mayor o igual a 5 cm.
              </small>
            </div>
            <span className="text-right">
              {Math.round(
                indicadoresEstablecimiento.posibilidadPastoreoCortoPlazo * 100
              )}{" "}
              %
            </span>
          </ListGroupItem>
          <ListGroupItem className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <span className="text-left text-muted">
                Posibilidad de pastoreo en el mediano plazo
              </span>
              <small className="text-left text-muted">
                Porcentaje del área mayor o igual a 2.5 cm.
              </small>
            </div>
            <span className="text-right">
              {Math.round(
                indicadoresEstablecimiento.posibilidadPastoreoMedianoPlazo * 100
              )}{" "}
              %
            </span>
          </ListGroupItem>
          <ListGroupItem className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <span className="text-left text-muted">
                Posibilidad de pastoreo en el largo plazo
              </span>
              <small className="text-left text-muted">
                Porcentaje del área menor a 2.5 cm.
              </small>
            </div>
            <span className="text-right">
              {Math.round(
                indicadoresEstablecimiento.posibilidadPastoreoLargoPlazo * 100
              )}{" "}
              %
            </span>
          </ListGroupItem>
        </ListGroup>
      </ModalBody>
      <ModalFooter>
        <Col>
          <Row className="justify-content-between">
            <Button color={"secondary"} onClick={() => onClose()}>
              Cerrar
            </Button>
          </Row>
        </Col>
      </ModalFooter>
    </Modal>
  );
};

export default IndicadoresProyeccionModal;
